<div class="Site-inner pt-5 pb-5">
	<div class="container legal-document">
		<markdown *ngIf="!invalidDocumentType" [data]="legalDocument.text"></markdown>
		<h1 *ngIf="invalidDocumentType">No document found!</h1>
		<h1 *ngIf="fetchingDocument">Fetching document, please wait...</h1>
	</div>
</div>